{
  "zh-TW": {
    "fleetDashboard": {
      "unnamed": "未命名",
      "formats": {
        "weekday": "EEE",
        "day": "d"
      },
      "activity": {
        "title": "最新動態",
        "you": "你",
        "kinds": {
          "member_joined": "加入了艦隊",
          "event_published": "活動已發布",
          "event_cancelled": "活動已取消",
          "contract_published": "合約已發布",
          "contract_claimed": "合約已認領",
          "contract_fulfilled": "合約已完成",
          "inventory_transfer_completed": "轉移已完成",
          "inventory_item_deposited": "已存入",
          "inventory_item_withdrawn": "已取出"
        },
        "empty": {
          "title": "還沒有動態",
          "hint": "已發布的活動和合約會顯示在這裡，最新的在最前。"
        }
      },
      "events": {
        "title": "即將到來的活動",
        "signUp": "報名",
        "empty": {
          "title": "未來兩週沒有安排",
          "hint": "查看活動頁面了解之後的安排。",
          "hintCreate": "在日曆上安排一次行動，成員即可立即報名。",
          "action": "安排活動"
        }
      },
      "actionQueue": {
        "title": "待你處理",
        "joinRequests": {
          "one": "%{count} 個入隊申請",
          "other": "%{count} 個入隊申請"
        },
        "pendingTransfers": {
          "one": "%{count} 個待處理的轉入",
          "other": "%{count} 個待處理的轉入"
        },
        "partFailed": "部分待處理事項暫時無法載入。",
        "empty": {
          "title": "全部處理完畢",
          "hint": "需要回應的入隊申請和傳入轉移會顯示在這裡。"
        },
        "memberHealth": {
          "one": "%{count} 項成員檢查需要處理",
          "other": "%{count} 項成員檢查需要處理"
        }
      },
      "contracts": {
        "title": "合約",
        "mine": "你的工作",
        "open": "可接取",
        "partFailed": "部分合約暫時無法載入。",
        "empty": {
          "title": "沒有開放的合約",
          "hint": "在合約面板查看以往的工作。",
          "hintCreate": "發布一項工作，成員即可接取。",
          "action": "發布合約"
        }
      },
      "inventory": {
        "title": "庫存",
        "empty": "最近沒有庫存變動。",
        "emptyMine": "最近沒有與你相關的變動。",
        "emptyHint": "存入、取出和轉移會顯示在這裡。",
        "mine": "我的",
        "fleet": "艦隊"
      },
      "newMembers": {
        "title": "新成員",
        "empty": {
          "title": "最近沒有新成員",
          "hint": "成員加入後會顯示在這裡。"
        }
      },
      "about": {
        "title": "關於艦隊",
        "empty": {
          "title": "還沒有簡介",
          "hint": "艦隊還沒有介紹自己。",
          "hintEdit": "告訴新成員艦隊是做什麼的。",
          "action": "撰寫簡介"
        }
      },
      "week": {
        "emptyDay": "%{day} 沒有安排。"
      },
      "online": {
        "title": "目前在線（%{count}）",
        "titlePending": "目前在線",
        "friend": "好友",
        "more": {
          "one": "還有 %{count} 人",
          "other": "還有 %{count} 人"
        },
        "empty": {
          "title": "沒有其他人在線",
          "hint": "成員登入後會立即顯示在這裡。"
        }
      },
      "announcements": {
        "post": "發布公告",
        "postAction": "發布",
        "edit": "編輯公告",
        "body": "公告",
        "until": "截至 %{date}",
        "confirmRemove": "要為所有人刪除此公告嗎？",
        "expiry": {
          "label": "顯示時長",
          "keep": "保持目前截止時間",
          "never": "直到被刪除",
          "day": "一天",
          "days3": "三天",
          "week": "一週",
          "weeks2": "兩週"
        },
        "messages": {
          "saved": "公告已儲存。",
          "saveFailed": "無法儲存公告。",
          "removed": "公告已刪除。",
          "removeFailed": "無法刪除公告。"
        },
        "more": {
          "one": "再顯示 %{count} 則公告",
          "other": "再顯示 %{count} 則公告"
        }
      }
    }
  }
}
